import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { Field } from '@cordata/buffet';

import Dropzone from '~/components/common/Dropzone';
import useApi from '~/utils/api/hook';

const PublicResourceUrlField = () => {
  const { setFieldValue, values: { publicResourceFile } } = useFormikContext();
  const { api } = useApi();

  useEffect(() => {
    if (publicResourceFile) {
      api
        .post('/s3-upload', {
          ...publicResourceFile,
          bucket: process.env.REACT_APP_IMAGES_S3_BUCKET,
        }).then(r => setFieldValue('publicResourceUrl', r.data.link));
    }
  }, [publicResourceFile]);

  return (
    <>
      <Field
        name="publicResourceUrl"
        required
      />

      <Dropzone
        setFile={f => setFieldValue('publicResourceFile', f)}
        acceptFileTypes="image/*"
      />
    </>
  );
};

export default PublicResourceUrlField;
